import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";

// Utils
import combineURLs from "../../utilities/url/combine-urls.utility";
import { toHijriDate } from "../../utilities/date/to-hijri-date.utility";
import getErrorMessage from "../../utilities/api/get-error-message.utility";

// Store
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "react-query";

// Hooks
import { useGetWaitingCollectRequests } from "../../hooks/api/collect-request/use-get-waiting-collect-requests.hook";
import { useGetBanners } from "../../hooks/api/banner/use-get-banner.hook";
import { useApiViewStatus } from "../../hooks/api/api-view-status/api-view-status.hook";

// Styles
import "./home.style.scss";

// Assets
import homeEmptyImg from "../../assets/images/home/home-requests-empty.svg";
// import giftIcon from "../../assets/images/gift.svg";
// import handPointing from "../../assets/images/hand-pointing.svg";

// Enums
import RequestStatusEnum from "../../utilities/enums/request-statuses.enum";
import { citizenMembershipsTypes } from "../../constants/user-memberships.constant";

// Config
import axiosBaseConfig from "../../configs/axios/axios-base.config";
import allEnvs from "../../configs/env.config";

// Components
import { Button, Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import Toast from "../../components/toast/toast.component";
import { BaseIcon } from "../../components/base-icon/base-icon.component";
import { BottomSheet } from "react-spring-bottom-sheet";
import HomeRubbishList from "./home-rubbish-list.view";

import clsx from "clsx";

function Home() {
	const queryClient = useQueryClient();

	const currentUser = useSelector((state) => state.currentUser);

	// const [isOpenAutomaticCharityModal, setIsOpenAutomaticCharityModal] = useState(false);

	// const requestCancellationReasonsQueryInfo = useGetRequestCancellationReasons();

	// const filteredCancellationReasonsAfterSubmitRequest = useMemo(() => {
	// 	const reasons = requestCancellationReasonsQueryInfo.data ?? [];

	// 	return reasons.filter((reason) => {
	// 		return reason.type === UserRequestCancellationTypes.afterSubmit.value;
	// 	});
	// }, [requestCancellationReasonsQueryInfo.data]);
	const [isCancelReasonBottomSheetOpen, setIsCancelReasonBottomSheetOpen] = useState(false);

	// const [selectedRequestCancellationReason, setSelectedRequestCancellationReason] = useState();

	// const rejectCollectionRequestMutation = useMutation(
	// 	({ reason, requestId }) => {
	// 		return axiosBaseConfig.post("v2/userSupportReason", {
	// 			supportReasonId: reason.id,
	// 			requestId,
	// 		});
	// 	},
	// 	{
	// 		onError(err) {
	// 			const errorMessage = getErrorMessage(err);
	// 			toast.error(<Toast description={errorMessage} type="error" />);
	// 		},

	// 		onSuccess(response, { requestId }) {
	// 			cancelRequest.mutate(requestId);
	// 		},
	// 	}
	// );

	const citiesData = useSelector((state) => state.globalData?.initData?.city);
	const { city: userCity = null, lastCollectedRequest = null } = useSelector((state) => state.currentUser);

	const cityUrl = citiesData?.find((city) => city?.id === userCity?.id)?.subUrl;

	const bannersQueryInfo = useGetBanners();
	const waitingCollectRequestsQueryInfo = useGetWaitingCollectRequests();

	const { bannersApiIndicatorShow, apiIndicatorComponent: BannersApiIndicatorComponent } = useApiViewStatus(
		bannersQueryInfo.status
	);

	const { waitingCollectRequestApiIndicatorShow, apiIndicatorComponent: WaitingCollectRequestApiIndicatorComponent } =
		useApiViewStatus(waitingCollectRequestsQueryInfo.status);

	const citiesList = useSelector((state) => state.globalData?.initData?.city);
	const userCityData = citiesList?.find((city) => city?.id === userCity?.id);

	const cityLocation = {
		lat: Number(userCityData?.Lat),
		lng: Number(userCityData?.Lng),
	};

	const onHomeBannerClick = (bannerData) => {
		switch (bannerData.type) {
			case 1:
				const fakeLink = document.createElement("a");
				fakeLink.href = bannerData.data;
				fakeLink.target = "_blank";
				fakeLink.click();
				break;
			case 2: {
				const fakeLink = document.createElement("a");
				fakeLink.href = `tel:${bannerData.data}`;
				fakeLink.click();
				break;
			}
			default:
				break;
		}
	};

	const navigate = useNavigate();

	const parsedPlate = (plateNum) => {
		const [_, plateInitNums, plateChar, plateLastNums, plateCity] = plateNum;
		return {
			plateInitNums,
			plateChar,
			plateLastNums,
			plateCity,
		};
	};

	const driverCarData = (requestId) => {
		if (!requestId) {
			requestId = waitingCollectRequestsQueryInfo?.data?.[0]?.requestId;
		}
		const request = waitingCollectRequestsQueryInfo?.data?.find((item) => item.requestId === requestId);
		const carData = request?.carName?.split(":");
		if (carData) {
			return {
				carType: carData[0],
				plate: parsedPlate(carData),
			};
		}
		return {
			carType: "",
			plate: "",
		};
	};
	const driverCarDetails = driverCarData();

	const hasUserPrevCollectedRequest =
		lastCollectedRequest?.location?.lat && lastCollectedRequest?.location?.lng && lastCollectedRequest?.address;

	const formattedDate = (givenDate) => {
		const date = toHijriDate(givenDate);
		return `${date.weekdayName} ${date.dayNumber} ${date.monthName}`;
	};

	const onCancelRequest = () => {
		setIsCancelReasonBottomSheetOpen(true);
	};
	const callDriver = (phone) => {
		if (!phone) return;

		window.location.href = `tel:${phone}`;
	};

	const cancelRequest = useMutation(({ requestId }) => axiosBaseConfig.delete(`/shared/request/${requestId}`), {
		onError(err) {
			const errorMessage = getErrorMessage(err);

			toast.error(<Toast description={errorMessage} type="error" />);
		},
		onSuccess() {
			queryClient.invalidateQueries({ queryKey: ["waitingCollectingRequests"] });
			setIsCancelReasonBottomSheetOpen(false);
		},
	});

	// useEffect(() => {
	// 	if (
	// 		typeof currentUser?.intentData?.productId !== "number" &&
	// 		!localStorage.getItem("isOpenAutomaticCharityModal")
	// 	) {
	// 		setIsOpenAutomaticCharityModal(true);
	// 	}
	// }, [currentUser?.intentData]);

	return (
		<>
			{/* <BottomSheet
				open={isOpenAutomaticCharityModal}
				onDismiss={() => {
					setIsOpenAutomaticCharityModal(false);
					localStorage.setItem("isOpenAutomaticCharityModal", false);
				}}
			>
				<div className="d-flex align-items-end">
					<img src={handPointing} className="img-fluid" />

					<div className="me-25">
						<p className="fw-900 mb-50">اهدا ۲۰% به خیریه</p>
						<p className="text-muted f-12 fw-400">عشقِ شما، لبخند و زندگی هدیه می‌کنه!</p>
					</div>
				</div>
				<Container>
					<div className="f-12 fw-400 mb-150">
						با فعال‌سازی، پس از جمع‌آوری هر درخواست شما، ۲۰% مبلغ دریافتی‌تون برای اهدای زندگی، عشق و لبخند
						به خیریه اهدا می‌شه.
					</div>

					<div className="d-flex justify-content-center mb-200">
						<img src={giftIcon} alt="gift" />
					</div>

					<div>
						<p className="f-12 fw-400 mb-75 text-muted d-flex align-items-center">
							<BaseIcon name="Flag1" size={12} className="ms-50" />
							گزارش نتیجۀ واریزی‌های شما، در سوشال کارو اطلاع‌رسانی می‌شه.{" "}
						</p>

						<p className="f-12 fw-400 mb-0 text-muted d-flex align-items-center">
							<BaseIcon name="Settings" size={12} className="ms-50" />
							هر زمان که متمایل بودین، می‌تونین از تنظیمات این امکان رو لغو کنین.
						</p>
					</div>

					<div className="pt-200 pb-100">
						<Row className="gx-50">
							<Col xs={4}>
								<Button
									onClick={() => {
										setIsOpenAutomaticCharityModal(false);
										localStorage.setItem("isOpenAutomaticCharityModal", false);
									}}
									color="semi-danger"
									className="d-block w-100"
								>
									نه!
								</Button>
							</Col>

							<Col xs={8}>
								<Button
									className="btn btn-semi-primary d-block w-100"
									onClick={() => {
										navigate("/shop/charities", {
											state: {
												isAutomaticCharity: true,
											},
										});
										setIsOpenAutomaticCharityModal(false);
										localStorage.setItem("isOpenAutomaticCharityModal", false);
									}}
								>
									چه عالی؛ انجامش می‌دم!
								</Button>
							</Col>
						</Row>
					</div>
				</Container>
			</BottomSheet> */}

			<Container>
				<>
					<HomeRubbishList location={cityLocation} />

					{bannersApiIndicatorShow ? (
						<div className="w-100 rounded rounded-1 bg-light mb-100" style={{ minHeight: "200px" }} />
					) : (
						<section className="mb-100">
							<div className="home-banner-holder">
								<Swiper
									modules={[Pagination, Autoplay]}
									spaceBetween={0}
									slidesPerView={1}
									pagination={{ clickable: true }}
									autoplay={{
										delay: 5000,
									}}
									centeredSlides={true}
									centeredSlidesBounds={true}
									longSwipes={false}
								>
									{bannersQueryInfo.data?.map((banner) => (
										<SwiperSlide key={banner.id} onClick={() => onHomeBannerClick(banner)}>
											<img
												src={combineURLs(`${allEnvs.storageBaseUrl}`, banner.img)}
												className="img-fluid w-100"
											/>
										</SwiperSlide>
									))}
								</Swiper>
							</div>
						</section>
					)}
					<section className="mb-200">
						<Row className="gx-50">
							<Col xs={6}>
								<Link to="/rubbishes-price" className="btn btn-card btn-lg w-100">
									<div className="dis-vet-center justify-content-center">
										<span className="ms-25 dis-vet-center">
											<BaseIcon name="ListLeft" size={14} strokeWidth={2} />
										</span>
										<span>قیمت پسماندِ خشک</span>
									</div>
								</Link>
							</Col>
							<Col xs={6}>
								<Link to="/invitation" className="btn btn-card btn-lg w-100">
									<div className="dis-vet-center justify-content-center">
										<span className="ms-25 dis-vet-center">
											<BaseIcon name="Share1" size={14} strokeWidth={2} />
										</span>
										<span>معرفی به دوستان</span>
									</div>
								</Link>
							</Col>
						</Row>
					</section>

					{waitingCollectRequestApiIndicatorShow ? (
						<WaitingCollectRequestApiIndicatorComponent />
					) : (
						<section>
							{waitingCollectRequestsQueryInfo?.data?.length ? (
								currentUser.roleId === citizenMembershipsTypes.citizen.value ? (
									waitingCollectRequestsQueryInfo?.data?.[0]?.status ===
									RequestStatusEnum.assigned.value ? (
										<div>
											<h3 className="fw-900 f-14 mb-100">درخواست‌های فعّال شما</h3>
											<Card>
												<CardBody>
													<div className="dis-vet-center mb-150 justify-content-between">
														<h5 className="f-14 fw-700 mb-0">جمع‌آوری پسماندِ خشک</h5>
														<span className="f-12 fw-400">
															<span>برای </span>
															<span>
																{formattedDate(
																	waitingCollectRequestsQueryInfo?.data?.[0]?.runDate
																)}
															</span>
														</span>
													</div>
													<div>
														<ul className="collecting-request-data list-unstyled">
															<li className="dis-vet-center justify-content-between">
																<span className="f-12 fw-400">بازۀ انتخابی</span>
																<span className="f-12 fw-500">
																	<span>
																		{
																			waitingCollectRequestsQueryInfo?.data?.[0]
																				?.startPeriod
																		}
																	</span>
																	<span className="mx-25">الی</span>
																	<span>
																		{
																			waitingCollectRequestsQueryInfo?.data?.[0]
																				?.endPeriod
																		}
																	</span>
																</span>
															</li>
															<li className="dis-vet-center justify-content-between">
																<span className="f-12 fw-400">وضعیت</span>
																<span className="dis-vet-center">
																	<span
																		className={clsx(
																			"status-badge badge-small ms-25",
																			{
																				["badge-green"]: true,
																			}
																		)}
																	/>
																	<span className="f-12 fw-500">تخصیص داده شده</span>
																</span>
															</li>
															<li className="dis-vet-center justify-content-between">
																<span className="f-12 fw-400">کد تحویل</span>
																<span className="dis-vet-center">
																	<span className="f-12 fw-500">
																		{
																			waitingCollectRequestsQueryInfo?.data?.[0]
																				?.otp
																		}
																	</span>
																</span>
															</li>
															<li className="dis-vet-center justify-content-between">
																<span className="f-12 fw-400">سفیر</span>
																<span className="f-12 fw-500">{`${waitingCollectRequestsQueryInfo?.data?.[0]?.driverName} ${waitingCollectRequestsQueryInfo?.data?.[0]?.driverFamily}`}</span>
															</li>
															<li className="dis-vet-center justify-content-between">
																<span className="f-12 fw-400">خودرو</span>
																<span className="f-12 fw-500">
																	{driverCarDetails.carType}
																</span>
															</li>
															<li className="dis-vet-center justify-content-between">
																<span className="f-12 fw-400">پلاک</span>
																<div>
																	<div className="plate-holder">
																		<span className="plate-city">
																			{driverCarDetails?.plate?.plateCity}
																		</span>
																		<span className="plate-content">
																			<span>
																				{driverCarDetails?.plate?.plateLastNums}
																			</span>
																			<span className="mx-25">
																				{driverCarDetails?.plate?.plateChar}
																			</span>
																			<span>
																				{driverCarDetails?.plate?.plateInitNums}
																			</span>
																		</span>
																	</div>
																</div>
															</li>
															<li className="f-12 fw-300 text-end">
																{waitingCollectRequestsQueryInfo?.data?.[0]?.address}
															</li>
														</ul>
														<div className="d-flex justify-content-between">
															<Button
																className="w-100 btn-danger-link btn-normalized"
																onClick={onCancelRequest}
															>
																<div className="dis-vet-center justify-content-center text-center">
																	<span className="ms-50 dis-vet-center">
																		<BaseIcon name="CrossSmall" size={16} />
																	</span>
																	<span>لغو درخواست</span>
																</div>
															</Button>

															<Button
																className="w-100 btn-info-link btn-normalized"
																onClick={() =>
																	callDriver(
																		waitingCollectRequestsQueryInfo?.data?.[0]
																			?.driverMobile
																	)
																}
															>
																<div className="dis-vet-center justify-content-center text-center">
																	<span className="ms-50 dis-vet-center">
																		<BaseIcon name="PhoneCall" size={16} />
																	</span>
																	<span>تماس با راننده</span>
																</div>
															</Button>
														</div>
													</div>
												</CardBody>
											</Card>
										</div>
									) : (
										<div>
											<h3 className="fw-900 f-14 mb-100">درخواست‌های فعّال شما</h3>
											<Card>
												<CardBody>
													<div className="dis-vet-center mb-150 justify-content-between">
														<h5 className="f-14 fw-700 mb-0">جمع‌آوری پسماندِ خشک</h5>
														<span className="f-12 fw-400">
															<span>برای </span>
															<span>
																{formattedDate(
																	waitingCollectRequestsQueryInfo?.data?.[0]?.runDate
																)}
															</span>
														</span>
													</div>
													<div>
														<ul className="collecting-request-data list-unstyled">
															<li className="dis-vet-center justify-content-between">
																<span className="f-12 fw-400">بازۀ انتخابی</span>
																<span className="f-12 fw-500">
																	<span>
																		{
																			waitingCollectRequestsQueryInfo?.data?.[0]
																				?.startPeriod
																		}
																	</span>
																	<span className="mx-25">الی</span>
																	<span>
																		{
																			waitingCollectRequestsQueryInfo?.data?.[0]
																				?.endPeriod
																		}
																	</span>
																</span>
															</li>
															<li className="dis-vet-center justify-content-between">
																<span className="f-12 fw-400">وضعیت</span>
																<span className="dis-vet-center">
																	<span
																		className={clsx(
																			"status-badge badge-small ms-25",
																			{
																				["badge-orange"]: true,
																			}
																		)}
																	/>
																	<span className="f-12 fw-500">در انتظار</span>
																</span>
															</li>
															<li className="dis-vet-center justify-content-between">
																<span className="f-12 fw-400">کد تحویل</span>
																<span className="dis-vet-center">
																	<span className="f-12 fw-500">
																		{
																			waitingCollectRequestsQueryInfo?.data?.[0]
																				?.otp
																		}
																	</span>
																</span>
															</li>
															<li className="f-12 fw-300 text-end">
																{waitingCollectRequestsQueryInfo?.data?.[0]?.address}
															</li>
														</ul>
														<Button
															onClick={onCancelRequest}
															color="success"
															className="w-100 btn-danger-link btn-normalized"
														>
															<div className="dis-vet-center justify-content-center text-center">
																<span className="ms-50 dis-vet-center">
																	<BaseIcon name="CrossSmall" size={16} />
																</span>
																<span>لغو درخواست</span>
															</div>
														</Button>
													</div>
												</CardBody>
											</Card>
										</div>
									)
								) : (
									<>
										{waitingCollectRequestsQueryInfo?.data?.map((request) =>
											request.status === RequestStatusEnum.assigned.value ? (
												<div key={request.requestId}>
													<h3 className="fw-900 f-14 mb-100">درخواست‌های فعّال شما</h3>
													<Card>
														<CardBody>
															<div className="dis-vet-center mb-150 justify-content-between">
																<h5 className="f-14 fw-700 mb-0">
																	جمع‌آوری پسماندِ خشک
																</h5>
																<span className="f-12 fw-400">
																	<span>برای </span>
																	<span>{formattedDate(request?.runDate)}</span>
																</span>
															</div>
															<div>
																<ul className="collecting-request-data list-unstyled">
																	<li className="dis-vet-center justify-content-between">
																		<span className="f-12 fw-400">
																			بازۀ انتخابی
																		</span>
																		<span className="f-12 fw-500">
																			<span>{request?.startPeriod}</span>
																			<span className="mx-25">الی</span>
																			<span>{request?.endPeriod}</span>
																		</span>
																	</li>
																	<li className="dis-vet-center justify-content-between">
																		<span className="f-12 fw-400">وضعیت</span>
																		<span className="dis-vet-center">
																			<span
																				className={clsx(
																					"status-badge badge-small ms-25",
																					{
																						["badge-green"]: true,
																					}
																				)}
																			/>
																			<span className="f-12 fw-500">
																				تخصیص داده شده
																			</span>
																		</span>
																	</li>
																	<li className="dis-vet-center justify-content-between">
																		<span className="f-12 fw-400">کد تحویل</span>
																		<span className="dis-vet-center">
																			<span className="f-12 fw-500">
																				{request?.otp}
																			</span>
																		</span>
																	</li>
																	<li className="dis-vet-center justify-content-between">
																		<span className="f-12 fw-400">سفیر</span>
																		<span className="f-12 fw-500">{`${request?.driverName} ${request?.driverFamily}`}</span>
																	</li>
																	<li className="dis-vet-center justify-content-between">
																		<span className="f-12 fw-400">خودرو</span>
																		<span className="f-12 fw-500">
																			{driverCarData(request.requestId).carType}
																		</span>
																	</li>
																	<li className="dis-vet-center justify-content-between">
																		<span className="f-12 fw-400">پلاک</span>
																		<div>
																			<div className="plate-holder">
																				<span className="plate-city">
																					{
																						driverCarData(request.requestId)
																							?.plate?.plateCity
																					}
																				</span>
																				<span className="plate-content">
																					<span>
																						{
																							driverCarData(
																								request.requestId
																							)?.plate?.plateLastNums
																						}
																					</span>
																					<span className="mx-25">
																						{
																							driverCarData(
																								request.requestId
																							)?.plate?.plateChar
																						}
																					</span>
																					<span>
																						{
																							driverCarData(
																								request.requestId
																							)?.plate?.plateInitNums
																						}
																					</span>
																				</span>
																			</div>
																		</div>
																	</li>
																	<li className="f-12 fw-300 text-end">
																		{request?.address}
																	</li>
																</ul>
																<div className="d-flex justify-content-between">
																	<Button
																		className="w-100 btn-danger-link btn-normalized"
																		onClick={onCancelRequest}
																	>
																		<div className="dis-vet-center justify-content-center text-center">
																			<span className="ms-50 dis-vet-center">
																				<BaseIcon name="CrossSmall" size={16} />
																			</span>
																			<span>لغو درخواست</span>
																		</div>
																	</Button>

																	<Button
																		className="w-100 btn-info-link btn-normalized"
																		onClick={() =>
																			callDriver(request?.driverMobile)
																		}
																	>
																		<div className="dis-vet-center justify-content-center text-center">
																			<span className="ms-50 dis-vet-center">
																				<BaseIcon name="PhoneCall" size={16} />
																			</span>
																			<span>تماس با راننده</span>
																		</div>
																	</Button>
																</div>
															</div>
														</CardBody>
													</Card>
												</div>
											) : (
												<div key={request.requestId}>
													<h3 className="fw-900 f-14 mb-100">درخواست‌های فعّال شما</h3>
													<Card>
														<CardBody>
															<div className="dis-vet-center mb-150 justify-content-between">
																<h5 className="f-14 fw-700 mb-0">
																	جمع‌آوری پسماندِ خشک
																</h5>
																<span className="f-12 fw-400">
																	<span>برای </span>
																	<span>{formattedDate(request?.runDate)}</span>
																</span>
															</div>
															<div>
																<ul className="collecting-request-data list-unstyled">
																	<li className="dis-vet-center justify-content-between">
																		<span className="f-12 fw-400">
																			بازۀ انتخابی
																		</span>
																		<span className="f-12 fw-500">
																			<span>{request?.startPeriod}</span>
																			<span className="mx-25">الی</span>
																			<span>{request?.endPeriod}</span>
																		</span>
																	</li>
																	<li className="dis-vet-center justify-content-between">
																		<span className="f-12 fw-400">وضعیت</span>
																		<span className="dis-vet-center">
																			<span
																				className={clsx(
																					"status-badge badge-small ms-25",
																					{
																						["badge-orange"]: true,
																					}
																				)}
																			/>
																			<span className="f-12 fw-500">
																				در انتظار
																			</span>
																		</span>
																	</li>
																	<li className="dis-vet-center justify-content-between">
																		<span className="f-12 fw-400">کد تحویل</span>
																		<span className="dis-vet-center">
																			<span className="f-12 fw-500">
																				{request?.otp}
																			</span>
																		</span>
																	</li>
																	<li className="f-12 fw-300 text-end">
																		{request?.address}
																	</li>
																</ul>
																<Button
																	onClick={onCancelRequest}
																	color="success"
																	className="w-100 btn-danger-link btn-normalized"
																>
																	<div className="dis-vet-center justify-content-center text-center">
																		<span className="ms-50 dis-vet-center">
																			<BaseIcon name="CrossSmall" size={16} />
																		</span>
																		<span>لغو درخواست</span>
																	</div>
																</Button>
															</div>
														</CardBody>
													</Card>
												</div>
											)
										)}
										<div className="py-300 d-flex flex-column align-items-center">
											<img src={homeEmptyImg} className="mb-100" />
											<p className="f-12 fw-400 text-center mb-150">
												طبیعت هنوز به شما احتیاج داره، سهم‌ِتون رو ادا کنین
											</p>
											<Button
												color="primary"
												className="px-200"
												onClick={() => {
													navigate(`/new-collection-request`, {
														state: {
															withPrevCollectionRequestLocation: true,
														},
													});
												}}
											>
												ثبت درخواست با آخرین آدرس
											</Button>
										</div>
									</>
								)
							) : hasUserPrevCollectedRequest ? (
								<div className="py-300 d-flex flex-column align-items-center">
									<img src={homeEmptyImg} className="mb-100" />
									<h5 className="fw-900 f-16 mb-50 text-center">درخواست فعّالی ندارین!</h5>
									<p className="f-12 fw-400 text-center mb-150">
										طبیعت هنوز به شما احتیاج داره، سهم‌ِتون رو ادا کنین
									</p>
									<Button
										color="primary"
										className="px-200"
										onClick={() => {
											navigate(`/new-collection-request`, {
												state: {
													withPrevCollectionRequestLocation: true,
												},
											});
										}}
									>
										ثبت درخواست با آخرین آدرس
									</Button>
								</div>
							) : (
								<div className="py-300 d-flex flex-column align-items-center">
									<img src={homeEmptyImg} className="mb-100" />
									<h5 className="fw-900 f-16 mb-50 text-center">هنوز درخواستی ثبت نکردین!</h5>
									<p className="f-12 fw-400 text-center mb-150">
										کافیه روی دکمۀ زیر بزنین و بقیۀ مراحل رو ادامه بدین :)
									</p>
									<Button
										color="primary"
										className="px-200"
										onClick={() => {
											navigate("/new-collection-request");
										}}
									>
										ثبت درخواستِ جمع‌آوری
									</Button>
								</div>
							)}
						</section>
					)}
				</>
			</Container>

			<BottomSheet open={isCancelReasonBottomSheetOpen} onDismiss={() => setIsCancelReasonBottomSheetOpen(false)}>
				<Container className="px-100 pb-100 pt-25">
					<p className="mb-50 fw-900 f-16"> لغو درخواست</p>
					{/* <p className="f-12 fw-400 mb-50"> لطفا بهمون بگین چرا قصد دارین درخواستتون رو لغو کنین؟</p> */}
					<p className="f-12 fw-400 mb-50">از لغو درخواست مطمئن هستین؟</p>

					{/* {requestCancellationReasonsQueryInfo.isLoading && (
						<div className=" mb-50 d-flex py-150  justify-content-center ">
							<Spinner color="primary" />
						</div>
					)}
					<ul className="list-unstyled p-0 m-0 list-bt mb-50">
						{filteredCancellationReasonsAfterSubmitRequest.map((cancellationReason) => {
							return (
								<li
									key={cancellationReason?.id}
									onClick={() => {
										setSelectedRequestCancellationReason(cancellationReason);
									}}
								>
									<div className="d-flex">
										<div
											className={clsx(`ms-50 request-reject-reason-circle`, {
												active:
													cancellationReason?.id === selectedRequestCancellationReason?.id,
											})}
										/>
										<span className="f-12 fw-500">{cancellationReason?.description ?? ""}</span>
									</div>
								</li>
							);
						})}
					</ul> */}

					<div className="d-flex justify-between my-100 gap-50">
						<Button
							color="danger"
							outline
							block
							disabled={cancelRequest.isLoading}
							onClick={() => setIsCancelReasonBottomSheetOpen(false)}
						>
							<span>نه، لغو نشه لطفا</span>
						</Button>

						<Button
							color="danger"
							block
							disabled={cancelRequest.isLoading}
							onClick={() =>
								cancelRequest.mutate({
									requestId: waitingCollectRequestsQueryInfo?.data?.[0]?.requestId,
								})
							}
						>
							{cancelRequest.isLoading ? (
								<div className="dis-vet-center justify-content-center">
									<Spinner color="secondary" size="sm" />
								</div>
							) : (
								<span>بله، لغو بشه</span>
							)}
						</Button>
					</div>
				</Container>
			</BottomSheet>

			{/* <NewUpdateDetailsModal /> */}

			{/* <BottomSheet
				open={isCancelReasonBottomSheetOpen}
				onDismiss={() => setIsCancelReasonBottomSheetOpen(false)}
			>
				<Container>
					<div className="py-100">
						<div className="pt-75 mb-250">
							<h2 className="fw-900 f-16 mb-75">لغو درخواست جمع‌آوری</h2>
							<p className="fw-400 f-12">از لغوِ درخواستِ جمع‌آوری مطمئن هستین؟</p>
						</div>
						<div className="d-flex justify-content-center mb-250">
							<svg xmlns="http://www.w3.org/2000/svg" width="126" height="74" fill="none">
								<path
									stroke="#000"
									stroke-linejoin="round"
									stroke-width="1.024"
									d="M10.247 47.553a10.692 10.692 0 0 0 4.773-1.458 10.868 10.868 0 0 0 3.62-3.476c1.391-2.15 2.36-4.959-.113-6.758a7.959 7.959 0 0 0-1.937-.952 8.522 8.522 0 0 0-2.33-.584c-4.079-.28-7.429 4.225-7.923 7.922-.724 5.41 3.217 11.118 8.703 11.32 3.487.124 7.648-2.663 8.667-6.076.51-1.655.816-4.2-.948-5.228-2.335-1.36-5.241 1.892-6.796 3.195-1.469 1.236-3.12 2.524-3.865 4.37-1.499 3.728 1.106 8.046 4.364 9.727 3.467 1.79 8.387-1.934 10.146-4.897.765-1.293 1.494-3.723.347-5.042-1.682-1.934-5.22.398-6.725 1.417-3.15 2.13-6.888 4.545-4.97 8.843.324.732.727 1.426 1.202 2.068.888 1.205 2.086 2.524 3.488 3.067 3.202 1.236 7.138-.249 9.07-3.036 1.117-1.593 2.208-6.102-.79-6.376-1.458-.13-2.687.838-3.916 1.464M29.57 21.076c-1.682 3.14-3.452 8.005-1.326 11.377.857 1.355 3.717 4.618 5.634 3.165 1.75-1.324 2.58-3.956 3.141-5.999 1.091-3.971 2.162-7.757-1.433-10.808a8.744 8.744 0 0 0-1.891-1.282c-2.473-1.169-5.15.134-7.582.776M1.62 23.419c-.973 1.137-.759 2.818.348 4.607 1.886 3.056 6.118 7.964 6.118 7.964l2.773-2.865a88.507 88.507 0 0 1-5.904-8.093c-.397-.641-1.239-2.265-1.152-3.077.087-.812.78-1.417 1.26-1.939a25.91 25.91 0 0 1 4.43-3.672c1.876-1.287 3.926-2.358 5.848-3.62.546-.346 1.708-1.282 2.391-1.24 1.438.093 2.432 1.82 3.12 2.9 1.911 3.1 3.652 6.305 5.216 9.598"
								/>
								<path
									stroke="#000"
									stroke-linejoin="round"
									stroke-width="1.024"
									d="M34.424 36.435c3.008 5.083 6.388 10.026 9.723 14.903.87 1.282 1.733 2.57 2.59 3.863.209.31.846 1.034.816 1.406-.072.848-.816 1.624-1.367 2.183-1.422 1.453-8.637 6.758-9.034 7.105-1.066.92-2.04 1.644-2.769 1.215a8.477 8.477 0 0 1-2.279-1.655c-.933-1.106-1.188-2.037-1.85-1.773-.577.232-2.973 1.277-1.678 2.725.688.765 1.703 1.913 2.666 2.834.964.92 1.744.362 1.917.16"
								/>
								<path
									stroke="#000"
									stroke-linejoin="round"
									stroke-width="1.024"
									d="M37.244 67.348c2.04.227 4.135-.517 6.027-1.262 1.672-.662 3.385-1.262 4.884-2.29 3.503-2.42 6.261-6.723 5.068-11.057a17.02 17.02 0 0 0-6.282-9.127 10.802 10.802 0 0 0-3.319-1.551 9.586 9.586 0 0 0-1.142-.259c-.204-.026-.642.16-.611-.041.107-.662.423-1.174.367-1.898-.21-2.585-2.412-4.457-4.416-5.74M48.344 65.135c2.666-.125 5.073.956 7.556 1.778 3.059 1.035 6.164 2.028 9.177 3.294 2.11.895 4.14 2.069 6.322 2.793"
								/>
								<path
									stroke="#000"
									stroke-linejoin="round"
									stroke-width="1.024"
									d="M43.959 40.313c3.375 1.034 6.837 1.82 10.284 2.586 4.37.982 8.667 1.768 13.149 1.55 2.233-.118 5.22-.113 7.3-1.033M124.112 12.389c-6.286-2.586-13.43-3.62-20.139-4.37-4.793-.517-9.524-1.319-14.342-1.624-1.479-.098-3.06-.46-4.548-.341-3.171.248-6.322 1.975-9.315 2.989-3.243 1.096-6.45 2.332-9.626 3.594-1.53.615-3.416 1.034-4.68 2.192-2.443 2.198-3.911 5.45-5.349 8.357-1.346 2.72-2.82 5.373-4.079 8.119-.607 1.293-1.371 2.761-1.101 4.25.115.664.465 1.261.984 1.681 1.295 1.097 5.098 2.446 6.791 1.324 2.249-1.474 3.304-3.935 4.742-6.123a131.753 131.753 0 0 1 6.592-9.127c.836-1.065 3.4-3.795 2.04-5.259-.592-.636-1.627-.346-2.203.13-1.08.9-1.458 2.435-1.637 3.774-.826 6.05-.035 16.093 7.684 16.89.926.148 1.87.125 2.789-.068 1.121-.32 1.35-1.8 1.53-2.792a25.24 25.24 0 0 0-.296-8.274c-.108-.605-.51-3.129-1.326-3.351-.54-.15-.913 1.64-.959 1.955-.275 1.934.342 3.935.821 5.791.847 3.294 1.285 8.486 5.354 9.127.962.101 1.932.086 2.89-.046a7.56 7.56 0 0 0 2.958-.719c1.02-.584 1.121-2.234 1.137-3.273.046-3.04-.857-6.206-2.1-8.946-.43-.947-.857-1.898-1.342-2.808-.04-.078-.382-.786-.51-.73-.871.378-.958 1.552-.968 2.364-.031 2.068.81 4.044 1.596 5.92.693 1.671 1.447 4.138 3.156 5.063 1.02.57 2.421.192 3.492-.103 2.886-.791 6.45-2.296 8.158-4.887 2.121-3.164.295-6.205-1.683-8.79-.51-.678-1.086-1.831-1.948-2.116-1.488-.48-5.328.46-6.01 2.203-.562 1.427-.19 3.103.234 4.51.336 1.142.652 2.487 1.336 3.485"
								/>
								<path
									stroke="#000"
									stroke-linejoin="round"
									stroke-width="1.024"
									d="M104.968 29.878c1.866-1.583 2.906-3.89 3.416-6.247.148-.693 0-1.898.275-2.508.128-.295.362.517.51.78.306.476.591.963.892 1.444a25.691 25.691 0 0 0 3.008 3.92c3.386 3.65 7.342 5.76 11.931 7.544M72.454 14.974c1.723-1.432 4.4-2.446 6.669-1.99.357.028.696.169.97.402.275.234.47.549.56.9.03.176-.28 1.423-.51 1.21-.143-.134.77-1.034.892-1.122a3.488 3.488 0 0 1 3.207-.331c1.172.409 2.55 1.552 2.722 2.86.078.509.05 1.028-.081 1.526-.072.248-.444.92-.413.662.088-.585.299-1.144.618-1.64.32-.494.74-.914 1.233-1.23 1.09-.72 3.253-1.464 4.354-.352.719.729.775 1.924.535 2.87-.025.108-.28.962-.48.936-.198-.026.103-.481.21-.698.26-.529.59-1.018.984-1.453a5.998 5.998 0 0 1 2.037-1.446 5.924 5.924 0 0 1 2.44-.483M91.625 4.797c-3.987-1.525-8.158-3.02-12.38-3.62-2.38-.336-5.037-.325-7.045 1.216-2.86 2.239-4.64 5.962-6.68 8.961"
								/>
							</svg>
						</div>
						<div className="d-flex">
							<Button
								block
								outline
								color="danger"
								className="ms-50"
								onClick={() => setIsCancelReasonBottomSheetOpen(false)}
							>
								نه، لغو نشه لطفا
							</Button>
							<Button
								block
								color="danger"
								onClick={() =>
									onSubmitCancelRequest(waitingCollectRequestsQueryInfo?.data?.[0]?.requestId)
								}
							>
								بله، لغو بشه
							</Button>
						</div>
					</div>
				</Container>
			</BottomSheet>  */}
		</>
	);
}

export default Home;
